/**
 * Cash Flow Dashboard - API Configuration
 *
 * Centralized endpoint constants for the Cash Flow report API.
 * Backend: insight-api -> routers/report/cash_flow (model Odoo cash.flow.report).
 */

export const CASH_FLOW_API_CONFIG = {
    BASE_PATH: '/report/pijar/cash-flow',

    endpoints: {
        DETAIL: '/report/pijar/cash-flow/detail',
        SUMMARY: '/report/pijar/cash-flow/summary',
        TREND: '/report/pijar/cash-flow/trend',
        WEEKLY: '/report/pijar/cash-flow/weekly',
    },
} as const;

/**
 * Default filter settings
 */
export const CASH_FLOW_DEFAULTS = {
    COMPANY_ID: 1,
    TREND_MONTHS: 6,
} as const;
